import { h, render } from 'preact';
import { useEffect } from 'preact/hooks';
import { waitForElm } from '../utils/helpers';
import Title from './title-square';
import Content from './content-square';
import Product from './product-square';

export default (element, data) => {
  const blocks = {
    title: (props) => <Title {...props} />,
    content: (props) => <Content {...props} />,
    product: (props) => <Product {...props} />,
  };

  const GiftGrid = () => {
    useEffect(() => {
      waitForElm('.yotpo.bottomLine').then(() => {
        if (window.yotpo?.initWidgets) {
          window.yotpo.initWidgets();
          let attempts = 0;
          const interval = setInterval(() => {
            if (
              element.querySelectorAll('.yotpo-bottomline a').length > 0 ||
              attempts > 1000
            ) {
              clearInterval(interval);
              window.yotpo.widgets.map((widget) => {
                const widgetNodeStarsText = widget.element.querySelector(
                  '.yotpo-bottomline a',
                );
                if (widgetNodeStarsText) {
                  widgetNodeStarsText.remove();
                }
                return '';
              });
            }
            attempts += 1;
          }, 100);
        }
      });
    }, []);
    return (
      <div>
        <ul className="flex laptop:bg-white scrollbar-hide px-5 overflow-auto py-4 laptop:py-7 laptop:justify-center gap-4 laptop:gap-8">
          {data.linksList.map((link, index) => (
            <li key={index}>
              <a className="cta-small whitespace-nowrap" href={link.link}>
                {link.title}
              </a>
            </li>
          ))}
        </ul>
        <div className="grid grid-cols-2	laptop:grid-cols-4">
          {data.blocks.map((block) =>
            blocks[block.type]({
              settings: block.settings,
              isLaptop: data.layout.isAboveBreakpoint('lg'),
            }),
          )}
        </div>
      </div>
    );
  };

  const init = () => {
    render(<GiftGrid data={data} />, element);
  };

  init();
};
